import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  BooleanStrict,
  mcpExposeMetadata,
  ResponseMetaSchema,
  ToolSchema,
  URLParamsSchema,
} from '../models';

extendZodWithOpenApi(z);
const c = initContract();

import { apiToolsConfigs } from './contract.tools.configs';

/**
 * Paths
 */
export const apiTools = c.router({
  getTools: {
    method: 'GET',
    path: `/1.0/tools`,
    description: `Tools (aka apps, services, websites, etc) that are supported in Timely Integration Cloud.`,
    query: z.object({
      accountId: URLParamsSchema.accountId,
      scope: URLParamsSchema.scope.optional().openapi({ description: 'Filter by scope' }),
      onlyConnected: BooleanStrict.default(false).openapi({
        description: 'Only return tools that are connected to the `accountId`',
      }),
      onlyProviders: BooleanStrict.default(false).openapi({
        description: `Only return tools that are providers.`,
      }),
      earlyAdopter: BooleanStrict.default(true).openapi({
        description: `Return early adopter tools/providers.`,
      }),
    }),
    responses: {
      200: z.object({ tools: z.array(ToolSchema), meta: ResponseMetaSchema }),
    },
    metadata: mcpExposeMetadata,
  },
  getToolsRecommendedOnAccount: {
    method: 'GET',
    path: `/1.0/tools/account_recommendations`,
    description: `Returns tools that the workspace/account has set up, but user has not yet connected to`,
    query: z.object({
      accountId: URLParamsSchema.accountId,
      personalAccountId: URLParamsSchema.accountId.openapi({
        description: `The personal account id of the user (where personal integrations are installed)`,
      }),
    }),
    responses: {
      200: z.object({ tools: z.array(ToolSchema), meta: ResponseMetaSchema }),
    },
  },
  getToolId: {
    method: 'GET',
    path: `/1.0/tools/:toolId`,
    description: `Tools (aka apps, services, websites, etc) that are supported in Timely Integration Cloud.`,
    pathParams: z.object({
      toolId: z.string().openapi({ description: 'The id of the tool', example: 'github' }),
    }),
    query: z.object({
      accountId: URLParamsSchema.accountId,
    }),
    responses: {
      200: z.object({ tool: ToolSchema }),
    },
    metadata: mcpExposeMetadata,
  },
  ...apiToolsConfigs,
});
